"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.record = void 0;
exports.record = {
    path: "M11.6666 1.66667H4.99998C4.08331 1.66667 3.33331 2.41667 3.33331 3.33333V16.6667C3.33331 17.5833 4.07498 18.3333 4.99165 18.3333H15C15.9166 18.3333 16.6666 17.5833 16.6666 16.6667V6.66667L11.6666 1.66667ZM13.3333 10H6.66665V11.6667H13.3333V10ZM13.3333 13.3333H6.66665V15H13.3333V13.3333ZM4.99998 16.6667H15V7.5H10.8333V3.33333H4.99998V16.6667Z",
    originalWidth: 20,
    originalHeight: 20,
    basicColor: "tableGray1",
    activeColor: "tableBlack2"
};
